module.exports = __webpack_public_path__ + "img/angststoerungen1_1920.74f13be6.webp";